import { render, staticRenderFns } from "./MaterialesListado.vue?vue&type=template&id=c354ba0e"
import script from "./MaterialesListado.vue?vue&type=script&lang=js"
export * from "./MaterialesListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports